import React from 'react';
import { motion } from 'framer-motion';
import './PharmApp.css';

const PharmApp = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const features = [
    {
      icon: '📊',
      title: 'Real-Time Monitoring',
      description: 'Track milk production, animal health, and farm operations in real-time with intuitive dashboards.'
    },
    {
      icon: '🔍',
      title: 'Traceable Logs',
      description: 'Complete traceability from cow to consumer with QR codes and blockchain-verified records.'
    },
    {
      icon: '🔔',
      title: 'Smart Alerts',
      description: 'AI-powered notifications for health issues, feeding schedules, and critical farm events.'
    },
    {
      icon: '📱',
      title: 'Mobile-First',
      description: 'Access your farm data anywhere, anytime with our responsive mobile and web applications.'
    }
  ];

  return (
    <div className="pharmapp-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background parallax-container">
          <div className="parallax-bg" style={{
            backgroundImage: 'linear-gradient(rgba(11, 19, 43, 0.7), rgba(11, 19, 43, 0.8)), url(https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1920)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}></div>
        </div>
        <div className="container hero-content">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-headline"
          >
            PharmApp — The Brain of Your Farm
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="hero-subheadline"
          >
            Intelligent farm management system that brings transparency, efficiency, and data-driven insights to modern dairy operations.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="hero-ctas"
          >
            <button className="btn btn-primary">Schedule a Demo</button>
            <button className="btn btn-outline">View Features</button>
          </motion.div>
        </div>
      </section>

      {/* Dashboard Preview */}
      <section className="section dashboard-section">
        <div className="container">
          <motion.div
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="dashboard-preview"
          >
            <div className="dashboard-mockup card">
              <div className="dashboard-header">
                <div className="dashboard-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <h3>PharmApp Dashboard</h3>
              </div>
              <div className="dashboard-content">
                <div className="dashboard-widget">
                  <div className="widget-header">Today's Production</div>
                  <div className="widget-value">1,247 L</div>
                </div>
                <div className="dashboard-widget">
                  <div className="widget-header">Active Cows</div>
                  <div className="widget-value">42</div>
                </div>
                <div className="dashboard-widget">
                  <div className="widget-header">Health Alerts</div>
                  <div className="widget-value">2</div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Features Section */}
      <section className="section features-section">
        <div className="container">
          <motion.h2
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="section-title"
          >
            Powerful Features
          </motion.h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <motion.div
                key={feature.title}
                initial="initial"
                whileInView="animate"
                viewport={{ once: true }}
                variants={fadeInUp}
                transition={{ delay: index * 0.15 }}
                className="feature-card card card-gold"
              >
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <motion.div
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="cta-block"
          >
            <h2>Transform Your Farm Operations</h2>
            <p>Join leading dairy farms using PharmApp to optimize production, ensure traceability, and improve animal welfare.</p>
            <button className="btn btn-primary">Schedule a Demo</button>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PharmApp;

